export default (state) => state['sportsbook/essentialScores'];
